import { z } from "zod";
import { DateISO, DueType, EntitySource, Health, ProjectKind, ProjectStatus } from "../enums.js";
import { UserSummary } from "./user.js";
export const NextMilestone = z.object({
    step_id: z.string().uuid(),
    title: z.string(),
    due_date: DateISO.nullable(),
    due_type: DueType.nullable(),
});
export const Project = z.object({
    id: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    summary: z.string(),
    description: z.string(),
    status: ProjectStatus,
    health: Health,
    health_reason: z.string().nullable(),
    kind: ProjectKind,
    tags: z.array(z.string()),
    owner: UserSummary.nullable(),
    repo_url: z.string().nullable(),
    target_date: DateISO.nullable(),
    started_on: DateISO.nullable(),
    completed_at: z.string().nullable(),
    brief_version: z.number().int(),
    last_activity_at: z.string(),
    needs_review: z.boolean(),
    source: EntitySource,
    created_at: z.string(),
    updated_at: z.string(),
    // computed
    next_milestone: NextMilestone.nullable(),
    open_task_count: z.number().int(),
});
export const CreateProjectInput = z.object({
    name: z.string().min(1).max(160),
    summary: z.string().max(400).default(""),
    description: z.string().max(20000).default(""),
    kind: ProjectKind.default("other"),
    tags: z.array(z.string().min(1).max(40)).max(20).default([]),
    owner_id: z.string().uuid().nullable().optional(),
    repo_url: z.string().url().nullable().optional(),
    target_date: DateISO.nullable().optional(),
    status: ProjectStatus.default("idea"),
});
/** Sparse patch: omitted = keep. Explicit null clears nullable fields. */
export const UpdateProjectInput = z.object({
    name: z.string().min(1).max(160).optional(),
    summary: z.string().max(400).optional(),
    description: z.string().max(20000).optional(),
    kind: ProjectKind.optional(),
    tags: z.array(z.string().min(1).max(40)).max(20).optional(),
    owner_id: z.string().uuid().nullable().optional(),
    repo_url: z.string().url().nullable().optional(),
    target_date: DateISO.nullable().optional(),
    status: ProjectStatus.optional(),
    needs_review: z.boolean().optional(),
});
export const ProjectFilters = z.object({
    status: ProjectStatus.optional(),
    q: z.string().max(200).optional(),
    owner_id: z.string().uuid().optional(),
});
export const Brief = z.object({
    summary: z.string(),
    goals: z.array(z.string()),
    non_goals: z.array(z.string()),
    stakeholders: z.array(z.object({ name: z.string(), role: z.string(), org: z.string().nullable() })),
    tech_stack: z.array(z.string()),
    decisions: z.array(z.object({ id: z.string(), text: z.string(), date: DateISO.nullable(), source_id: z.string().nullable() })),
    open_questions: z.array(z.object({ id: z.string(), text: z.string(), owner: z.string().nullable(), raised_at: DateISO.nullable() })),
    risks: z.array(z.string()),
    links: z.array(z.object({ label: z.string(), url: z.string() })),
    glossary: z.array(z.object({ term: z.string(), meaning: z.string() })),
    last_updated_note: z.string(),
});
export const ProjectBrief = z.object({
    id: z.string().uuid(),
    project_id: z.string().uuid(),
    version: z.number().int(),
    brief: Brief.nullable(),
    markdown: z.string(),
    created_by: z.enum(["ai", "user"]),
    created_at: z.string(),
});
//# sourceMappingURL=project.js.map